import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { IEpGridModel } from '@epicor/kinetic';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-address-info-card',
  templateUrl: './epbt-fa-address-info-card.component.html',
  styleUrls: ['./epbt-fa-address-info-card.component.scss']
})
export class EpbtFaAddressInfoCardComponent implements OnInit {

  @Input()
  cardModel: IEpGridModel;
  bodyTemplate: TemplateRef<any>;
  headerTemplate: TemplateRef<any>;

  @Input()
  model: IEpGridModel;
  constructor() { }

  ngOnInit() {
  }

}
